


































































































































import {
  defineComponent,
  onMounted,
  ref,
  computed,
  watch,
  ComputedRef,
} from '@vue/composition-api';
import sl from '@/serviceLocator';
import { PersonInfo, PersonRole } from '@oare/types';
import TextOccurrences from '@/components/TextOccurrences/index.vue';

export default defineComponent({
  props: {
    uuid: {
      type: String,
      required: true,
    },
  },
  components: {
    TextOccurrences,
  },
  setup(props) {
    const server = sl.get('serverProxy');
    const actions = sl.get('globalActions');

    const loading = ref(false);
    const person = ref<PersonInfo>({
      person: {
        uuid: 'uuid',
        nameUuid: null,
        relation: null,
        relationNameUuid: null,
        label: '',
        descriptor: null,
      },
      display: '',
      father: null,
      mother: null,
      asshatumWives: [],
      amtumWives: [],
      husbands: [],
      siblings: [],
      children: [],
      temporaryRoles: [],
      durableRoles: [],
      discussion: [],
      roleNotYetAssigned: 0,
    });

    const getPerson = async () => {
      try {
        loading.value = true;
        person.value = await server.getPersonInfo(props.uuid);
      } catch (err) {
        actions.showErrorSnackbar(
          'Error retrieving person info. Please try again.',
          err as Error
        );
      } finally {
        loading.value = false;
      }
    };

    onMounted(async () => await getPerson());

    watch(
      () => props.uuid,
      async () => await getPerson()
    );

    const personHasData = computed(() => {
      return (
        person.value.father ||
        person.value.mother ||
        person.value.husbands.length > 0 ||
        person.value.asshatumWives.length > 0 ||
        person.value.amtumWives.length > 0 ||
        person.value.siblings.length > 0 ||
        person.value.children.length > 0 ||
        person.value.discussion.length > 0 ||
        person.value.durableRoles.length > 0 ||
        person.value.temporaryRoles.length > 0
      );
    });

    const occurrencesLoading = ref(false);
    const occurrencesCount = ref(0);

    watch(person, async () => {
      try {
        occurrencesLoading.value = true;
        const response = await server.getPersonsOccurrencesCounts([props.uuid]);
        if (response.length > 0) {
          occurrencesCount.value = response[0].count;
        }
      } catch (err) {
        actions.showErrorSnackbar(
          'Error retrieving person occurrences. Please try again.',
          err as Error
        );
      } finally {
        occurrencesLoading.value = false;
      }
    });

    const textOccurrencesDialog = ref(false);

    const disconnectPerson = async (discourseUuids: string[]) => {
      try {
        await Promise.all(
          discourseUuids.map(discourseUuid =>
            server.disconnectPersons(discourseUuid, props.uuid)
          )
        );
        occurrencesCount.value -= discourseUuids.length;
        actions.showSnackbar('Person occurrence(s) successfully disconnected');
      } catch (err) {
        actions.showErrorSnackbar(
          'Error disconnecting person from occurrences. Please try again.',
          err as Error
        );
      }
    };

    const selectedRole = ref<PersonRole>();
    const roleNotYetAssignedPlaceHolder: ComputedRef<PersonRole> = computed(
      () => ({
        role: 'occuring in texts where a role has not yet been assigned',
        roleUuid: 'noRole',
        occurrences: person.value.roleNotYetAssigned,
      })
    );

    const handleSelectOccurrences = (role: PersonRole | undefined) => {
      selectedRole.value = role;
      textOccurrencesDialog.value = true;
    };

    return {
      loading,
      person,
      personHasData,
      occurrencesLoading,
      occurrencesCount,
      textOccurrencesDialog,
      server,
      disconnectPerson,
      selectedRole,
      handleSelectOccurrences,
      roleNotYetAssignedPlaceHolder,
    };
  },
});
